export default __webpack_public_path__ + "static/media/bnb.cffe024b.svg";